import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import axios from "axios";
import storage from "redux-persist/lib/storage";
import jwtDecode from "jwt-decode";
import Swal from 'sweetalert2'
import Cookies from "universal-cookie";
import { SERVERURL } from "../ServerUrl";


const cookies = new Cookies();

const initialStateFunction = () => ({

  // getPricingData:[],
  getDriverBusData:[],
  currentDriver:[]
 


});



//login customer
export const loginDriver = createAsyncThunk("loginDriver", async (data) => {

  try {
    const data1 = await axios.post(
      `${SERVERURL}/loginDriver`,
      
      data
    );

    console.log("DataResDataRes", data1.data);

    console.log("DataResDataRes", data1.data);
    cookies.set('_id', data1?.data?.user?._id, { path: '/' });

    cookies.set("userType",data1?.data?.user?.userType,{ path: '/' });
    cookies.set("token",data1?.data?.token,{ path: '/' });


   
    return data1.data;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});


//login customer
export const getDriverBus = createAsyncThunk("getDriverBus", async (data) => {

 const id=cookies.get("_id");
  try {
    const data1 = await axios.get(
      `${SERVERURL}/driverVehicle/${id}`,
      
      data
    );



   
    return data1.data;
  } catch (err) {
    console.log("NoLoginError", err?.response?.data?.message);
  }
});





export const DriverReducer = createSlice({
  name: "DriverReducer",
  initialState: initialStateFunction(),
  reducers: {
    setCurrentUser(state, action) {
      state.currentUser = action.payload;
    },

    resetState: (state) => initialStateFunction(),
  },
  extraReducers: {
    [getDriverBus.fulfilled]: (state, action) => {
      state.getDriverBusData = action.payload;
    },
 
    [loginDriver.fulfilled]: (state, action) => {
      state.currentDriver = action.payload;
    },
 
   
  },
});




const persistConfig = {
  key: "root",
  storage,
  whitelist: ["DriverReducer"],
};

const user = DriverReducer.reducer;

// Action creators are generated for each case reducer function
export const { setCurrentUser } = DriverReducer.actions;
export default persistReducer(persistConfig, user);
